import * as preact from "preact";
import PropTypes from "prop-types";

import FormField from "../FormField";
import RadioButton from "../../RadioButton";

import "./style.css";

function RadioButtonFormField(props) {
    const {
        label,
        labelWidth,
        title,
        checked,
        disabled,
        onClick
    } = props;

    return (
        <FormField
            class="radioButtonFormField"
            label={label}
            labelWidth={labelWidth}
            disabled={disabled}>
            <label class="radioButtonContainer">
                <RadioButton checked={checked} onClick={onClick} disabled={disabled}/>
                <div class="radioButtonTitle">{title}</div>
            </label>
        </FormField>
    );
}

RadioButtonFormField.propTypes = {
    label: PropTypes.string,
    title: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired
};

export default RadioButtonFormField;
